import React, { useEffect, useState } from "react";
import { DatePicker } from "react-materialize";
import { useMediaQuery } from "react-responsive";

import { notifyError } from "../../../../../../helpers/helpers";
import Location from "../../../../../commanPage/location/Location";

function InspectionFeild({
  setInspectionStoreDetails,
  inspectionStoreDetails,
  locations,
  lastDate,
}) {
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  const handleShowData = (name) => {
    const value = document.querySelector(`#${name}`);
    value.click();
  };

  const handleDateChange = (date, name) => {
    if (!lastDate) {
      notifyError("Kindly provide the Auction Date first.");
      return;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    setInspectionStoreDetails({
      ...inspectionStoreDetails,
      [name]: formattedDate,
    });
  };

  const getMinDate = () => {
    const today = new Date();
    return new Date(today?.setDate(today.getDate() + 1));
  };

  const getMaxDate = () => {
    const today = new Date(lastDate);
    return lastDate ? new Date(today?.setDate(today.getDate() - 1)) : null;
  };

  const [values, setValues] = useState({
    location: {
      longitude: "",
      latitude: "",
      address: "",
    },
  });

  useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      location: {
        ...prevValues.location,
        address: locations,
      },
    }));
  }, [locations]);

  useEffect(() => {
    setInspectionStoreDetails((prevEditValue) => ({
      ...prevEditValue,
      inspectionLocation: values?.location?.address,
    }));
  }, [values]);


  return (
    <div
      className={`${isMobile ? "column width-95" : "mt-2 mb-1"} grid-3 mr-2`}
    >
      <InputTagRerender
        labelName="Inspected by"
        name="inspectionBy"
        memory={inspectionStoreDetails}
        setMemory={setInspectionStoreDetails}
        type={"text"}
      />
      <span className="pin-top">
        <label className="font-16px black-text">
          Inspection Date <span className="red-text">*</span>
        </label>
        <DatePicker
          id="InspectionDate"
          role="input"
          type="date"
          name={"inspectionDate"}
          value={inspectionStoreDetails?.inspectionDate}
          onChange={(date) => {
            handleDateChange(date, "inspectionDate");
            document.body.style.overflow = "auto";
          }}
          options={{
            minDate: getMinDate(),
            maxDate: getMaxDate(),
          }}
          className="input-tag-style grey lighten-4 margin-0px"
          required
        />
        <span
          className="material-icons-outlined logo-Date-time pointer"
          onClick={() => handleShowData("InspectionDate")}
        >
          calendar_month
        </span>
      </span>
      <Location values={values} setValues={setValues} />
      <InputTagRerender
        labelName="Number of People"
        name="numberOfPeople"
        memory={inspectionStoreDetails}
        setMemory={setInspectionStoreDetails}
        type={"number"}
      />
      <InputTagRerender
        labelName="Contact Person Name"
        name="contactPerson"
        memory={inspectionStoreDetails}
        setMemory={setInspectionStoreDetails}
        type={"text"}
      />
    </div>
  );
}

const InputTagRerender = ({ labelName, name, memory, setMemory, type }) => {
  return (
    <span>
      <label className="black-text font-16px">
        {labelName} <span className="red-text">*</span>
      </label>
      <input
        className="input-tag-style grey lighten-4 margin-0px"
        type={type}
        placeholder={labelName}
        onChange={(e) =>
          setMemory({ ...memory, [name]: e.target.value?.trimStart() })
        }
      />
    </span>
  );
};

export default InspectionFeild;
